// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"40779312","672":"936fe004"}[chunkId] + ".chunk.css";
};